import { render } from "./AllFileMove.vue?vue&type=template&id=63d00c27"
import script from "./AllFileMove.vue?vue&type=script&lang=js"
export * from "./AllFileMove.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__